import { JobCatalogGenderData } from 'modules/job_catalog/components/JobCatalogPeopleCharts/models'

export const generateTickValues = (data: JobCatalogGenderData[], keys: string[]) => {
  const maxValue = getMaxStackValue(data, keys)
  if (maxValue === 0) return [0, 1]

  const tickValues = []
  const maxNumOftickValues = 5
  const upperLimit = Math.ceil(maxValue)
  const step = upperLimit > maxNumOftickValues ? Math.ceil(upperLimit / maxNumOftickValues) : 1
  for (let i = 0; i <= upperLimit; i += step) {
    tickValues.push(i)
  }

  return tickValues
}

const getMaxStackValue = (data: JobCatalogGenderData[], keys: string[]) => {
  let maxValue = 0
  data.forEach((item) => {
    let itemValue = 0
    keys.forEach((key) => {
      const value = item[key]
      if (typeof value === 'number') {
        itemValue += value
      }
    })
    if (itemValue > maxValue) {
      maxValue = itemValue
    }
  })
  return maxValue
}
